import { render, staticRenderFns } from "./GrantTitle.vue?vue&type=template&id=6bba11f8"
import script from "./GrantTitle.vue?vue&type=script&lang=js"
export * from "./GrantTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports